export const POSITIONS: any = {
	auto: 'auto',
	'auto-start': 'auto-start',
	'auto-end': 'auto-end',
	top: 'top',
	'top-left': 'top-start',
	'top-right': 'top-end',
	bottom: 'bottom',
	'bottom-left': 'bottom-start',
	'bottom-right': 'bottom-end',
	right: 'right',
	'right-start': 'right-start',
	'right-end': 'right-end',
	left: 'left',
	'left-start': 'left-start',
	'left-end': 'left-end',
};

export const DROPDOWN_ACCESSIBILITY_KEY_SET = [
	'Escape',
	'ArrowUp',
	'ArrowDown',
	'ArrowRight',
	'ArrowLeft',
	'Home',
	'End',
	'Enter',
];

export const OVERLAY_ACCESSIBILITY_KEY_SET = ['Escape', 'Tab'];

export const TABS_ACCESSIBILITY_KEY_SET = [
	'ArrowUp',
	'ArrowLeft',
	'ArrowDown',
	'ArrowRight',
	'Home',
	'End',
];

export const SELECT_ACCESSIBILITY_KEY_SET = [
	'ArrowUp',
	'ArrowLeft',
	'ArrowDown',
	'ArrowRight',
	'Home',
	'End',
	'Escape',
	'Enter',
	'Space',
	'Tab',
];

export const COMBO_BOX_ACCESSIBILITY_KEY_SET = [
	'ArrowUp',
	'ArrowLeft',
	'ArrowDown',
	'ArrowRight',
	'Home',
	'End',
	'Escape',
	'Enter',
];

export const BREAKPOINTS: any = {
	xs: 0,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	'2xl': 1536,
};